import { RadarQuadrant } from '@backstage/plugin-tech-radar';

export const quadrantsENUM = {
  PLATAFORMS: 'Plataforms',
  TECHNIQUES: 'Techniques',
  LANGUAGES_AND_FRAMEWORKS: 'Languages-and-frameworks',
  TOOLS: 'Tools',
}

const quadrants: RadarQuadrant[] = [
  { id: 'Plataforms', name: 'Plataforms' },
  { id: 'Techniques', name: 'Techniques' },
  { id: 'Languages-and-frameworks', name: 'Languages-and-frameworks' },
  { id: 'Tools', name: 'Tools' }
];

export default quadrants;
